/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  useResponsiveValue
 */

import { ResponsiveValue, useBreakpointValue } from '@chakra-ui/react'

export const useResponsiveValue = <T>(responsiveValue: ResponsiveValue<T> | undefined) => {
  const obj =
    typeof responsiveValue === 'object' && responsiveValue
      ? responsiveValue
      : { base: responsiveValue }
  return useBreakpointValue(obj)
}
